<template>
    <div>
      
        <section class="main-slider">
            <div class="page-header-bg"  style="background-image: url(static/picture/banner/B5.jpg);" >
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                        <!-- 资料下载 -->
                      {{ $t('resource.resource_breadcrumb_download') }}
                    </h1>
                    <h3>
                        <!-- 奥太电气智能制造产品与方案助力企业加速数字化转型升级 -->
                        {{ $t('resource.resource_download_banner_subtitle') }}
                    </h3>
                </div>
                <div class="page-header__breul">
                  
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'home' }">
                            <!-- 首页 -->
                            {{ $t('resource.resource_breadcrumb_home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: 'resourceList' }">
                            <!-- 资料中心 -->
                            {{ $t('resource.resource_breadcrumb_resourceCenter') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item >
                            <!-- 资料下载 -->
                            {{ $t('resource.resource_breadcrumb_download') }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>
      
        <!-- 内容 -->
        <section class="project-page" style="padding: 60px 0;">
            <div class="container">
                <div class="row row_page">
                    <div class="menu_row row_bg">
                        <div class="menu_item " v-for="(item,index) in typeList" :key="index" @click="getTypeData(item)" :class="downType==item.type ? 'menu_item_selected': ''" >
                            {{ item.label }}
                        </div>
                       
                    </div>
                    <div class="content_row row_bg">
                        <div v-if="tableData.length" style="height: 100%;">
                            <div style="height: 95%;">
                                <table class="table_div" >
                                    <tbody>
                                        <tr v-for="(item,index) in tableData" :key="index" class="tr_div">
                                            <td  class="td_div" >
                                                {{ item.name }}
                                            <!-- {{ $t(`resource.${item.i18n_name}`) }} -->
                                            </td>
                                            <td  class="td_action">
                                                
                                                <!-- <div v-if="downType == 'video'"><a @click="handleVideo(item)"  style="color: var(--notech-gray);"> <i style="font-size: var(--font-size-24)" class="el-icon-video-play"></i></a></div>
                                                <div v-else><a target="_blank" :href="item.downUrl" > <i style="font-size: var(--font-size-24)" class="el-icon-download"></i></a></div> -->
                                                <div v-if="item.type == 'video'"><a @click="handleSeek(item)"  style="color: var(--notech-gray);"> <i style="font-size: var(--font-size-24)" class="el-icon-video-play"></i></a></div>
                                                <div v-if="item.type == 'program'"><a @click="handleSeek(item)" > <i style="font-size: var(--font-size-24)" class="el-icon-download"></i></a></div>
                                                <!-- target="downloadFile" download :href="item.program"  -->
                                                <div v-if="item.type == 'view'"><a @click="handleSeek(item)"  > <i style="font-size: var(--font-size-24)" class="el-icon-view"></i></a></div>
                                                <!-- target="_blank" :href="item.viewUrl" -->
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="row" style="margin-top: 10px;">
                                <div class="col-lg-12">
                                        <div  class="blog-pagination justify-content-center">
                                        <el-pagination
                                            background
                                            layout="prev, pager, next"
                                            @size-change="handleSizeChange"
                                            @current-change="handleCurrentChange"
                                            :current-page="queryParam.pageNum"
                                            :page-size="queryParam.pageSize"
                                            :total="total"
                                        >
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="row_empty">
                            <el-empty :image-size="200"></el-empty>
                        </div>
                    </div>
                  
                </div>
               
            </div>
        </section>
        <div v-if="dialogVisible" class="video_dialog">
            <el-dialog  :visible.sync="dialogVisible" @closed="handleClose" >
                <video style="width: 900px;" ref="videoPlayer" :playsinline="true" autoplay="autoplay" loop="loop" :src="videoSrc" controls=""></video>
            </el-dialog>
        </div>

        <SeekDialog v-if="showSeek" type="resource" @close="seekClose" ></SeekDialog>
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
import SeekDialog from "@/components/seekDialog"
export default {
    name: 'resourceList',
    mixins: [MixinsList],
    components: {
        SeekDialog
    },
    data () {
        return {
            typeList: [
                { type: 'illustrate', label:  this.$t('resource.resource_type_illustrate') },   //'说明书',
                { type: 'material', label:  this.$t('resource.resource_type_material') },  // '样本资料'
                // { type: 'video', label: '宣传视频', },
                { type: 'program', label:  this.$t('resource.resource_type_program') }  // '应用程序'
            ], 
            downType: "",
            queryParam: {
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            tableData: [],
            dialogVisible: false,
            videoSrc: "",

            showSeek: false,
            dataParam: {},
            list: {},
        }
    },
    created() {
    
    },
    mounted () {
        this.getTypeData(this.typeList[0])
         // 确定选中的菜单
        $('.current').removeClass('current');  
        $('.resource_li').addClass('current');
    },
    methods: {
        getTypeData(item) {
            this.downType = item.type
            this.getList()
        },
        // 数据
        async getList() {
            // const { result } = res
            // var arr = JSON.parse(JSON.stringify(result[this.downType] )) 
            // this.total = arr.length
            // var p = (this.queryParam.pageNum-1)*this.queryParam.pageSize
            // this.tableData = arr.splice(p,this.queryParam.pageSize)
             try {
            let result = {}
            if( this.list && Object.keys(this.list).length > 0) {
                 result = this.list
            } else {
                result = await loadData('down', this.lang)
                this.list = result
            }
            
             
            var arr = JSON.parse(JSON.stringify(result[this.downType]))  
            this.total = arr.length
            var p = (this.queryParam.pageNum-1)*this.queryParam.pageSize
            this.tableData = arr.splice(p,this.queryParam.pageSize)
             } catch (error) {
               console.log("error",error)
           }


        },
        handleSizeChange(i, j) {
            Object.assign(this.queryParam, { pageSize: i })
            this.getList()
        },
        handleCurrentChange(i, j) {
            Object.assign(this.queryParam, { pageNum: i })
            this.getList()
        },
        // 打开视频
        handleVideo(item) {
            this.videoSrc = item.downUrl
            this.dialogVisible = true
        },
        handleClose() {
            
            let myPlayer = this.$refs.videoPlayer.player;
            console.log("1111111", myPlayer)
            myPlayer.pause()


            // this.dialogVisible = false
        },


        handleSeek(item) {
            this.dataParam = item
            this.showSeek = true
        },
        seekClose(val) {
            this.showSeek = false
            if(val == true) {
                if(this.dataParam.type == "video") {
                    this.handleVideo( this.dataParam)
                }
                if(this.dataParam.type == "program") {
                    this.handleDownload( this.dataParam)
                }
                if(this.dataParam.type == "view") {
                    this.handleView( this.dataParam)
                }
            }
            
        },

        handleDownload(item) {
            const link = document.createElement('a');
            link.href = item.program;
            link.download = true;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        handleView(item) {
            window.open(item.viewUrl, '_blank');
        }
        
    }
}
</script>
<style scoped>
.page-header-bg {
    background-color: transparent; 
}
.page-header__inner h1 {
    font-size: var(--font-size-40);
}
::v-deep iframe body header {
    display: none ;
}

/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    color: var(--notech-white);
    font-size: var(--font-size-16);
    font-weight: 700;
    transition: all 500ms ease;
}

.row_bg {
    position: relative;
    padding: 0;
    background: #fff;
    box-shadow: 0 5px 52px 0 rgba(19, 55, 159, 0.16);
    transition: all 0.36s;
}


.row_page {
    height: 850px;
    display: flex;
    justify-content: space-between;
}
.menu_row {
    max-height: 100%;
    width: 20%;
}
.menu_item {
    font-weight: 700;
    cursor: pointer;
    font-size: var(--font-size-20);
    width: 100%;
    text-align: center;
    padding: 10px;
    margin-bottom: 10px;
}
.menu_item_selected {
    color: #fff;
    background-color: var(--notech-base);
}
.content_row {
    max-height: 100%;
    width: 78%;
    padding: 28px;
}
.table_div {
    width: 100%;
    border-collapse: collapse; 
}
.tr_div {
    border-bottom: 1px solid #EBEEF5; 
    border-top: 1px solid #EBEEF5;
}
.tr_div:hover{
    background: #FAFAFA;
}
.td_div {
    font-size: var(--font-size-20);
    padding: 20px;
    width: 90%; 
    height: 40px; 
}
.td_action {
    cursor: pointer;
    color: #409EFF;
    width: 10%;  
    text-align: center;
}
.row_empty {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}


.row_empty
::v-deep .video_dialog .el-dialog {
    box-shadow: none;
		background: transparent;

	}
    ::v-deep .video_dialog .el-dialog__headerbtn .el-dialog__close {
		color: var(--notech-white) !important;
	}
</style> 
